import { render, staticRenderFns } from "./MobileAlbums.vue?vue&type=template&id=c26c340a&scoped=true&"
import script from "./MobileAlbums.vue?vue&type=script&lang=js&"
export * from "./MobileAlbums.vue?vue&type=script&lang=js&"
import style0 from "./MobileAlbums.vue?vue&type=style&index=0&id=c26c340a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26c340a",
  null
  
)

export default component.exports